var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutentificacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_64_8",
    "data-name": "Componente 64 \\u2013 8",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_271",
    "data-name": "Rect\\xE1ngulo 271",
    width: 32,
    height: 32,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "key_vertical_FILL0_wght300_GRAD0_opsz40",
    d: "M285.238-892.856a1.837,1.837,0,0,1,.559-1.345,1.829,1.829,0,0,1,1.343-.561,1.838,1.838,0,0,1,1.345.559,1.829,1.829,0,0,1,.561,1.343,1.838,1.838,0,0,1-.559,1.345,1.829,1.829,0,0,1-1.343.561,1.838,1.838,0,0,1-1.345-.559A1.829,1.829,0,0,1,285.238-892.856Zm-5.237,0a6.888,6.888,0,0,1,2.082-5.058A6.883,6.883,0,0,1,287.139-900a6.892,6.892,0,0,1,5.059,2.083,6.883,6.883,0,0,1,2.085,5.058,6.906,6.906,0,0,1-1.095,3.848,6.836,6.836,0,0,1-3.068,2.553v11.344a.985.985,0,0,1-.072.372,1.02,1.02,0,0,1-.232.338l-2.108,2.109a.971.971,0,0,1-.34.228,1.076,1.076,0,0,1-.385.068.938.938,0,0,1-.378-.075,1.034,1.034,0,0,1-.333-.244l-3.23-3.4a.83.83,0,0,1-.211-.3.991.991,0,0,1-.08-.349,1.167,1.167,0,0,1,.035-.336,1.013,1.013,0,0,1,.152-.321l1.375-1.877-1.469-2.011a.766.766,0,0,1-.139-.287,1.352,1.352,0,0,1-.035-.31,1.046,1.046,0,0,1,.048-.314.987.987,0,0,1,.139-.281l1.307-1.769v-2.586a6.9,6.9,0,0,1-2.994-2.454A6.719,6.719,0,0,1,280-892.858Zm1.631.013a5.165,5.165,0,0,0,1.2,3.369,5.378,5.378,0,0,0,2.962,1.89v4.291l-1.355,1.809c0-.017,0-.018,0,0s0,.016,0,0v0l1.89,2.633-1.8,2.376v0h0l2.492,2.58s0,.006-.011.012,0,0,.011-.012v0l1.47-1.47h0v-12.218a5.361,5.361,0,0,0,2.931-1.843,5.118,5.118,0,0,0,1.232-3.417,5.312,5.312,0,0,0-1.61-3.9,5.309,5.309,0,0,0-3.9-1.61,5.314,5.314,0,0,0-3.9,1.61A5.31,5.31,0,0,0,281.632-892.844Z",
    transform: "translate(-271.002 901.998)",
    fill: "#e7e7e7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutentificacion);
export default __webpack_public_path__ + "static/media/autentificacion.04fff53c25af0ff018d1c1ea83d55704.svg";
export { ForwardRef as ReactComponent };